import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import {
  Grid,
  Typography,
  Button,
  Box,
  styled,
  CircularProgress,
  FormHelperText,
} from "@mui/material";
import Header from "components/common/dialog/Header";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useDispatch } from "react-redux";
import { assetsObj } from "services/images";
import Footer from "components/common/dialog/Footer";
import { ForgotPassword } from "redux/slice/session/auth.slice";
import { emailRegex } from "services/utiles";
import { toast } from "react-toastify";
import { pathApp } from "services/utiles";

const WhiteBorderTextField = styled("input")({
  width: "100%",
  padding: "12px 14px",
  backgroundColor: "transparent",
  border: "1px solid white",
  borderRadius: "6px",
  color: "white",
  "&:focus": {
    borderColor: "#007AFF",
  },
  "&::placeholder": {
    color: "white",
  },
});

const Forgot = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const formik = useFormik({
    initialValues: {
      email: "",
      user_type: "",
    },
    enableReinitialize: true,

    validationSchema: Yup.object({
      email: Yup.string()
        .email("Email is invalid")
        .matches(emailRegex, "Invalid email format")
        .required("Email is required"),
    }),

    onSubmit: (value) => {
      value["user_type"] = 2;
      value["type"] = 1;
      setLoading(true);
      dispatch(ForgotPassword(value))
        .unwrap()
        .then((res) => {
          setLoading(false);
          if (res?.success) {
            navigate(`${pathApp}forgot-verification`);
            localStorage.setItem("email", value.email);
            localStorage.setItem("success", res?.success);
            toast.success("Your 4-digit code was sent to your email");
            // sessionStorage.setItem("token", res?.token);
          }
        });
    },
  });

  return (
    <>
      <Box
        sx={{
          height: "100%",
          color: "white",
          background: "black",
          overflow: "auto",
          position: "relative",
          "@media (max-width: 900px)": {
            backgroundImage: "none",
          },
        }}
      >
        <Header />

        <Box
          maxWidth="md"
          sx={{
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
            height: "calc(100vh - 133px)",
            maxWidth: "auto",
          }}
        >
          <form onSubmit={formik.handleSubmit}>
            <Grid container>
              <Grid
                item
                xs={12}
                md={6}
                className="leftContent"
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  position: "relative",
                }}
              >
                <Box
                  sx={{
                    maxHeight: { lg: "45vh", md: "40vh", xs: "20vh" },
                    position: "relative",
                    marginBottom: 4,
                    "@media (max-width: 900px)": {
                      marginBottom: 9,
                    },
                  }}
                  component="img"
                  src={assetsObj.forgotA}
                />
              </Grid>
              <Grid
                container
                item
                xs={12}
                md={6}
                sx={{
                  marginBottom: 5,
                }}
              >
                <Grid
                  container
                  item
                  xs={11}
                  md={8}
                  sx={{
                    margin: "auto",
                    "@media (max-width: 900px)": {
                      marginBottom: 9,
                    },
                  }}
                >
                  <Grid item xs={12}>
                    <Typography
                      variant="h4"
                      sx={{
                        fontWeight: 400,
                        textAlign: "center",
                        background:
                          "linear-gradient(90deg, rgba(191,90,242,1) 0%, rgba(123,90,255,1) 100%)",
                        backgroundClip: "text",
                        WebkitBackgroundClip: "text",
                        WebkitTextFillColor: "transparent",
                        marginBottom: 2,
                      }}
                    >
                      We’ll get you back on <br /> Affirmate in no time
                    </Typography>
                  </Grid>

                  <Grid item xs={12} sx={{ marginBottom: 2 }}>
                    <WhiteBorderTextField
                      placeholder="Your Email"
                      type="input"
                      name="email"
                      onChange={formik.handleChange}
                      value={formik.values.email}
                      onBlur={formik.handleBlur}
                    />
                    {formik.errors.email && (
                      <FormHelperText error>
                        {formik.errors.email}
                      </FormHelperText>
                    )}
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    sx={{ display: "flex", justifyContent: "center" }}
                  >
                    <Button
                      variant="contained"
                      sx={{
                        borderRadius: "60px",
                        width: "50%",
                        background: "transparent",
                        border: "1px solid white",
                        textTransform: "none",
                        "&:hover": {
                          background: "white",
                          color: "black",
                          transition: "0.2s ease-in-out",
                        },
                      }}
                      type="submit"
                    >
                      {loading ? (
                        <CircularProgress size={22} color="secondary" />
                      ) : (
                        "Send me the code"
                      )}
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </form>
        </Box>
        <Footer />
      </Box>
    </>
  );
};

export default Forgot;
